<template lang="pug">
  .order
    tour_info(v-bind="order" :title="order.tour_title" :date="order.day")
    booking_info(:order="order")

    .mb-3
      customer-order-list(
        :read_only="order.blocked_for_entity"
        :order_id="order.id"
        :lang="lang"
        role="agent"
        :max_links="max_customers"
        )
    template(v-if="(order.status === 'composing')")
      hr
      b-row
        b-col
          .float-right
            b-btn(@click="push_order" variant="primary" class="btn-gradient") Забронировать тур
    b-alert(:show="order.status === 'new'" variant="secondary" ) Заказ обрабатывается. Ожидайте подтверждения.

</template>

<script>
import Tour_info from "./tour_info";
import Booking_info from "./booking_info";
import Orderable from "../../../components/orders/Orderable";
import CustomerOrderList from "../../../components/orders/CustomerOrderList";
export default {
  name: "order_form",
  components: {CustomerOrderList, Orderable, Booking_info, Tour_info,},
  props: {
    role: {
      type: String,
      default: 'guest'
    },
    order_data: Object,
  },
  data(){
    return {
      local_order: this.order_data.data.attributes,
    }
  },
  computed:{
    order(){
      return this.$store.state.agents.order;
    },
    lang(){
      if (this.local_order.order_type == 2) return 'ru';
      if (this.local_order.order_type == 1) return 'en';
    },
    max_customers(){
      return this.$store.getters['agents/max_customers']
    },
  },
  beforeMount() {
    this.$store.commit('agents/setOrder', this.order_data.data.attributes);
  },
  methods: {
    push_order(){
      console.log('Patch order');
      this.$store.dispatch('agents/updateOrder', {
        id: this.order.id,
        data: {
          order: {
            status: 'new'
          }
        }
      })
    }
  }



}
</script>

<style scoped>

</style>